// @flow

import * as Sentry from '@sentry/react';

import {
  ErrorBoundary as ErrorBoundaryBase,
  type ErrorBoundaryProps,
} from 'react-error-boundary';

export function sendErrorReport(
  error: Error,
  info: { componentStack: string, ... },
): void {
  Sentry.captureException(error, { extra: info });
}

export function ErrorBoundary(props: ErrorBoundaryProps): React.MixedElement {
  return <ErrorBoundaryBase onError={sendErrorReport} {...props} />;
}
